import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

import { GraphQLTypes } from 'src/lib/graphqlTypes';
import { DatadogApiRegion } from 'src/lib/graphqlTypes/types';

import {
  updateDatadogApiKeyAndRegionMutation,
  updateDatadogEnabledMutation,
} from './graphql';

export const useSetDatadogEnabled = () => {
  const [mutate, { loading, error }] = useMutation<
    GraphQLTypes.UpdateDatadogEnabledMutation,
    GraphQLTypes.UpdateDatadogEnabledMutationVariables
  >(updateDatadogEnabledMutation);

  const setDatadogEnabled = useCallback(
    ({ serviceId, enabled }) =>
      mutate({
        variables: { serviceId, enabled },
        update: (cache) => {
          cache.evict({
            id: cache.identify({ __typename: 'Service', id: serviceId }),
            fieldName: 'datadogMetricsConfig',
          });
        },
      }),
    [mutate],
  );
  return { setDatadogEnabled, loading, error };
};

export const useSetDatadogApiKeyAndRegion = () => {
  const [mutate, { error }] = useMutation<
    GraphQLTypes.UpdateDatadogApiKeyAndRegionMutation,
    GraphQLTypes.UpdateDatadogApiKeyAndRegionMutationVariables
  >(updateDatadogApiKeyAndRegionMutation);

  const setDatadogApiKeyAndRegion = useCallback(
    ({
      serviceId,
      apiKey,
      apiRegion,
    }: {
      serviceId: string;
      apiKey: string;
      apiRegion: DatadogApiRegion | null;
    }) =>
      mutate({
        // TODO: remove non null assertion, added when typing the useCallback
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        variables: { serviceId, apiKey, apiRegion: apiRegion! },
        update: (cache) => {
          cache.evict({
            id: cache.identify({ __typename: 'Service', id: serviceId }),
            fieldName: 'datadogMetricsConfig',
          });
        },
      }),
    [mutate],
  );
  return { setDatadogApiKeyAndRegion, error };
};
